import $ from 'jquery'
import AnimatedDialogWrapper from "../../util/AnimatedDialogWrapper";
import DropdownTemplateView from "../../DropdownTemplateView";
import {showElementAt} from "../../atBrowserUtils"

export default class EditWorkflowStatusDialogWrapper extends AnimatedDialogWrapper{
    constructor($el, {
        dialog,
        className,
        onHide = () => {},
        preventHide = () => false
    }) {
        super($el, {
            dialog,
            className,
            onHide,
            preventHide
        })
    }

    afterRender(){
        super.afterRender()
        this.getEl().append('<div class="pointer"/>')
        this.pointer = this.find('.pointer')
    }

    _showElementAt($el, pos) {
        this.params.dialog.show()
        DropdownTemplateView.prototype._showElementAt.call(this, $el, {
            ...pos,
            my: 'left top',
            at: 'right center',
            offset: '14px -60px'
        })

        this._adjustPointer(pos)
    }

    _adjustPointer(pos){
        this.getEl().removeClass('pointerAtLeft pointerAtRight')

        let positionParams;
        if (this.getEl().offset().left + this.getEl().width() < $(pos.of).offset().left){
            this.getEl().addClass('pointerAtRight')
            positionParams = {
                ...pos,
                my: 'right center',
                at: 'left center',
                offset: '7px 0'
            }
        } else {
            this.getEl().addClass('pointerAtLeft')
            positionParams = {
                ...pos,
                my: 'left center',
                at: 'right center',
                offset: '-5px 0'
            }
        }

        showElementAt(this.pointer, positionParams)
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/workflowSettings/EditWorkflowStatusDialogWrapper.js